import { useCallback, useEffect, useMemo, useRef } from "react";
import { useState } from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-enterprise";
import {
  addStaticObject,
  getObjectGroupings,
  getObjects,
  getStaticObjectGridData,
  updateStaticObjectProperty,
} from "../../helpers/axios/objectsAxios.js";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import {
  agGridOptionsNone,
  agGridTheme,
} from "../../helpers/constants/Constants.js";

const StaticObjectLibrary = () => {
  const [objectGroupings, setObjectGroupings] = useState([]);
  const [selectedGroupingId, setSelectedGroupingId] = useState(null);
  const [gridData, setGridData] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newStaticObject, setNewStaticObject] = useState({
    name: null,
    muid: null,
    objectId: null,
  });
  const [groupObjects, setGroupObjects] = useState([]);

  useEffect(() => {
    (async () => {
      //Load groups and set the first to be selected
      let tempObjectGroupings = await getObjectGroupings();
      setObjectGroupings(tempObjectGroupings);
      setSelectedGroupingId(tempObjectGroupings[0].id);
    })();
  }, []);

  const loadGridData = useCallback(async () => {
    const tempStaticGridData =
      await getStaticObjectGridData(selectedGroupingId);
    setGridData(tempStaticGridData);
    const tempGroupObjects = await getObjects(selectedGroupingId);
    setGroupObjects(tempGroupObjects);
  }, [selectedGroupingId]);

  useEffect(() => {
    (async () => {
      if (selectedGroupingId != null) {
        //If group selected load the grid data
        await loadGridData();
      }
    })();
  }, [loadGridData, selectedGroupingId]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      // width: 300,
      // minWidth: 250,
      // flex: 1,
      filter: "agSetColumnFilter",
    }),
    [],
  );

  const onCellValueChanged = (event) => {
    updateStaticObjectProperty(
      event.data.muid,
      event.colDef.field,
      event.newValue,
    );
  };

  const selection = useMemo(() => {
    return {
      mode: "cell",
      handle: {
        mode: "fill",
        direction: "y", // Fill Handle can only be dragged horizontally
      },
    };
  }, []);

  return (
    <>
      {
        //Modal for adding new asset to the grid
        <Modal
          show={showAddModal}
          onHide={(e) => {
            setShowAddModal(false);
          }}
        >
          <Modal.Header>
            <Modal.Title>Add New Asset</Modal.Title>
            <div
              data-bs-theme="dark"
              style={{
                position: "absolute",
                right: 20,
              }}
            >
              <button
                type="button"
                className="btn-close"
                onClick={(e) => {
                  setShowAddModal(false);
                }}
                aria-label="Close"
              />
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center p-1">
              <input
                type="text"
                placeholder="Enter MUID"
                className="form-control"
                onChange={(e) => {
                  //update new asset MUID
                  setNewStaticObject({
                    ...newStaticObject,
                    muid: e.target.value,
                  });
                }}
              />
            </div>
            <div className="d-flex justify-content-center p-1">
              <input
                type="text"
                placeholder="Enter Name"
                className="form-control"
                onChange={(e) => {
                  //update new asset name
                  setNewStaticObject({
                    ...newStaticObject,
                    name: e.target.value,
                  });
                }}
              />
            </div>
            <div className="d-flex justify-content-center p-1">
              <Select
                placeholder="Select Object"
                className="w-100 text-black"
                options={groupObjects.map((object) => {
                  return { value: object.id, label: object.category };
                })}
                onChange={(e) => {
                  //update new asset object id
                  setNewStaticObject({ ...newStaticObject, objectId: e.value });
                }}
              />
            </div>
            <div className="d-flex justify-content-end p-1 mt-1 project-config-actions">
              <button
                className="btn btn-outline-success btn-sm project-config-action-btn"
                // className="btn mwh-btn-primary btn-sm project-config-action-btn"
                onClick={async (e) => {
                  //add row to grid
                  await addStaticObject(newStaticObject);
                  await loadGridData();
                  setShowAddModal(false);
                  //refresh grid
                }}
              >
                Add
              </button>
              <button
                className="btn btn-outline-success btn-sm project-config-action-btn"
                onClick={(e) => {
                  setShowAddModal(false);
                }}
              >
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>
      }
      <div>
        <div className="bs-docs-section" style={{ margin: 0 }}>
          <div className="col-lg-12">
            <div className="page-header">
              <h1
                id="tables"
                style={{
                  paddingTop: "5px",
                  paddingBottom: "5px",
                  margin: 0,
                }}
              >
                Static Object Library
              </h1>
            </div>
            {/* ObjectGroupings to change grid data */}
            <div className="d-flex justify-content-between m-1 project-config-actions">
              <div className="d-flex flex-wrap gap-1">
                {objectGroupings?.map((grouping) => {
                  if (
                    grouping.name === "Penstock & Stoplog" ||
                    grouping.name === "Filters" ||
                    grouping.name === "Pipework"
                  ) {
                    return <></>;
                  }
                  return (
                    <button
                      key={grouping.id}
                      className="btn btn-sm project-config-action-btn mwh-btn-primary"
                      onClick={() => {
                        setSelectedGroupingId(grouping.id);
                      }}
                    >
                      {grouping.name}
                    </button>
                  );
                })}
              </div>
              {/* Add new asset button */}
              {/* <div>
                <button
                  className="btn btn-sm btn-success"
                  onClick={(e) => {
                    setShowAddModal(true);
                  }}
                >
                  Add New Static Object
                </button>
              </div> */}
            </div>

            {/* Grid */}
            <div
              className="mt-2"
              style={{
                height: "80vh",
                width: "100%",
              }}
            >
              <AgGridReact
                theme={agGridTheme}
                ref={useRef(null)}
                rowData={gridData?.data}
                cellSelection={selection}
                columnDefs={gridData?.columns}
                defaultColDef={defaultColDef}
                singleClickEdit={false}
                onCellValueChanged={onCellValueChanged}
                gridOptions={agGridOptionsNone}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaticObjectLibrary;
